import React from 'react';
import { inject } from 'mobx-react';

import { networkBoundaryTypes } from '@kentik/ui-shared/dictionary/interfaceClassification';
import Link from 'core/components/Link';

const NetworkBoundaryLink = ({ $app, value, label, ...rest }) => {
  if (!value || !/[^-]/.test(value)) {
    return value || null;
  }

  const content = label || networkBoundaryTypes[value] || value;

  if ($app.isSubtenant) {
    return content;
  }

  return (
    <Link to={`/v4/core/quick-views/network-boundary/${value}`} {...rest}>
      {content}
    </Link>
  );
};

export default inject('$app')(NetworkBoundaryLink);
